module.exports = __webpack_public_path__ + "static/img/designGuide7.56ef03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide7.png
// module id = xXS3
// module chunks = 2